<template>
  <v-container fluid class="pa-2">
    
    <!-- HEADER / HERO SECTION -->
    <template v-if="!movie.direct && !isMovieLoading">
      <!-- TITLE CATEGORY SECTION -->
      <div class="px-2" v-if="!isDetails">
        <v-card
            flat
            color="transparent"
            class="px-0"
        >
          <div class="d-flex justify-space-between align-center flex-wrap">
            <div  class="d-flex justify-start align-center">
              <v-card-title class="px-2 text-break link-on-hover" @click.prevent="navigate('/browse/' + collection.id)">
                <strong>{{ collection.name || '' }} ></strong>
              </v-card-title>
              <v-btn
                  color="primary"
                  icon
                  small
                  @click.prevent="showItemDialog = true"
              >
                <v-icon
                    dark
                    small
                >
                  fal fa-circle-info
                </v-icon>
              </v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint.mobile">
              <v-btn
                  text
                  color="primary"
                  @click.prevent="navigate('/browse/' + collection.id)"
              >
                {{ $t('buttons.showAll') }}
              </v-btn>
              <!--            <v-btn
                              v-if="showAll"
                              text
                              color="primary"
                              @click.prevent="showAll = false"
                          >
                            {{ $t('buttons.showLess') }}
                          </v-btn>-->
            </div>
          </div>
        </v-card>
      </div>

      <!-- DETAILS SECTION -->
      <div class="px-2" v-if="isDetails">
        <div class="d-flex justify-space-between flex-wrap flex-md-row-reverse">
          <div class="col-12 col-md-4 pa-2 ma-0">
            <v-img
                v-if="collection.thumbnail"
                :src="collection.thumbnail"
                max-height="400"
                eager
            ></v-img>
          </div>
          
          <div class="col-12 col-md-6 pa-2 ma-0">
            <v-card
                flat
                color="transparent"
            >
              <v-card-title class="text-break"><strong>{{ collection.name || '' }}</strong></v-card-title>
              <v-card-text v-html="toMarkdown(collection.description)">
              </v-card-text>
            </v-card>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>
      </div>
    </template>

    <!-- PLAYER SECTION -->
    <template v-if="movie.direct || isMovieLoading">
      <div class="px-2" v-if="isMovieLoading">
        <div class="d-flex justify-space-between">
          <div class="col-12 pa-2 ma-0">
            <v-card
                flat
                color="transparent"                
            >
              <v-skeleton-loader
                  type="image"
              ></v-skeleton-loader>
            </v-card>
          </div>
        </div>
      </div>
      
      <div class="px-2" v-if="!isMovieLoading">
        <div class="d-flex justify-space-between">
          <div class="col-12 pa-2 ma-0">
            <v-card
                flat
                color="transparent"
                class="d-flex justify-center"
                height="60vh"
            >
              <template v-if="collection['live_video'] && collection['live_status'] === 'pending'">
                <v-img
                    v-if="collection.thumbnail"
                    :src="collection.thumbnail"
                    contain
                    eager
                ></v-img>
              </template>
              <template v-else>
                <iframe @load="logPlayer()" id="video" v-if="collection.metadata['series_id']" :src="movie.direct + '&sharing=0&api=1&chromeless=0&volume=100&context=' + encodeURI(baseUrl + '/series/' + collection.metadata['series_id'])+ '&back=' + collection.metadata['series_name']" height="100%" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="eager"></iframe>
                <iframe @load="logPlayer()" id="video" v-if="!collection.metadata['series_id']" :src="movie.direct + '&sharing=0&api=1&chromeless=0&volume=100'" height="100%" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="eager"></iframe>
              </template>
            </v-card>
          </div>
        </div>

        <div class="d-flex justify-space-between flex-wrap">
          <div class="col-12 col-lg-6 pa-2 ma-0">
            <v-card
                flat
                color="transparent"
            >
              <v-card-subtitle class="pb-0 text-break" v-if="collection.metadata"><a @click.prevent="navigate('/series/' + collection.metadata['series_id'])">{{ collection.metadata['series_name'] }}</a></v-card-subtitle>
              <v-card-title class="pt-0 text-break"><strong>{{ collection.name || '' }}</strong></v-card-title>
              <v-card-subtitle class="text-break" v-if="collection.duration && collection['live_status'] !== 'pending'">{{ collection.duration.formatted.substring(0, 3) === '00:' ? collection.duration.formatted.substring(3) : collection.duration.formatted }}</v-card-subtitle>
              <v-card-subtitle class="text-break" v-if="collection['live_video'] && collection['live_status'] === 'pending'">{{ $moment(collection['scheduled_at']).format('L LT') }}</v-card-subtitle>
              <v-card-text v-html="toMarkdown(collection.description)">
              </v-card-text>
            </v-card>
          </div>
          
          <div class="col-12 col-lg-6 pa-2 ma-0" v-if="collection['live_video'] && collection['live_status'] === 'pending'">
            <v-card
              flat
              color="transparent"
            >
              <v-card-subtitle class="text-break text-capitalize text-lg-end">{{ $moment(collection['scheduled_at']).fromNow() }}</v-card-subtitle>
            </v-card>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>
      </div>
    </template>

    <!-- ITEMS DETAILS SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading && isDetails">
      <template v-for="(serie, n) in series.collections">
        <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="serie.id + '-' + n">
          <v-card
            class="ma-2 my-0"
            color="transparent"
            flat
            tile
            height="100%"
            link
          >
            <v-hover v-slot="{ hover }">
              <v-img
                  :src="serie.thumbnail"
                  @click.prevent="goToCollection(serie)"
                  eager
              >
                <!-- CHIP FOR DURATION -->
                <v-chip
                    v-if="serie.duration && serie.type === 'video' && !serie['live_video']"
                    class="ma-2 rounded-lg"
                    label
                    small
                    color="primary"
                >
                  {{ serie.duration.formatted.substring(0, 3) === '00:' ? serie.duration.formatted.substring(3) : serie.duration.formatted }}
                </v-chip>
                <!-- CHIP FOR LIVE VIDEO -->
                <v-chip
                    v-if="serie.duration && serie.type === 'video' && serie['live_video']"
                    class="ma-2 rounded-lg"
                    label
                    small
                    color="secondary"
                >
                  {{ serie['live_status'] }}
                </v-chip>
                
                <v-fade-transition v-if="serie.type === 'video' && hover">
                  <v-overlay
                      v-if="hover"
                      absolute
                      color="black"
                  >
                    <v-icon
                        v-if="!serie['live_video'] || serie['live_status'] !== 'pending'"
                        color="primary"
                        large
                    >
                      fas fa-play
                    </v-icon>
                    <v-icon
                        v-else
                        color="primary"
                        large
                    >
                      fas fa-info-circle
                    </v-icon>
                  </v-overlay>
                </v-fade-transition>
              </v-img>
            </v-hover>
            <v-card-text class="d-flex justify-space-between align-start">
              <div>
                <div v-if="serie.name" @click.prevent="goToCollection(serie)"><strong>{{ serie.name }}</strong></div>
                <div v-if="serie.type === 'video' && serie['live_video'] && serie['live_status'] === 'pending'">{{ $moment(serie['scheduled_at']).format('L LT')}}</div>
                <div v-if="serie.type === 'video' && serie.episodeNumber">{{ $t('labels.episode') }} {{ serie.episodeNumber }}</div>
                <div v-if="serie.type === 'file' && serie.size">{{ serie.size.formatted }}</div>
              </div>
              <div>
                <v-btn
                    color="primary"
                    icon
                    small
                    @click.prevent="toggleDescription(serie.id)"
                >
                  <v-icon
                      v-if="!showDescriptions.includes(serie.id)"
                      dark
                      small
                  >
                    fal fa-chevron-down
                  </v-icon>
                  <v-icon
                      v-if="showDescriptions.includes(serie.id)"
                      dark
                      small
                  >
                    fal fa-chevron-up
                  </v-icon>
                </v-btn>
              </div>
            </v-card-text>
            <v-card-text v-if="showDescriptions.includes(serie.id)" style="max-height: 200px;" class="overflow-y-auto">
              <div v-if="serie.description" v-html="toMarkdown(serie.description)"></div>
            </v-card-text>
          </v-card>
        </div>
      </template>
    </div>
    
    <!-- ITEMS BROWSE SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading && !isDetails">
      <v-carousel
        hide-delimiters
        v-model="model"
        height="100%"
        :continuous="false"
        :cycle="false"
      >
        <template v-for="(serie, n) in series.collections">
          <v-carousel-item
              v-if="(n + 1) % columns === 1 || columns === 1"
              :key="'serie-slide-' + n"
              eager
          >
            <div class="col-12 ma-0 pa-0 d-flex flex-nowrap">
              <div v-for="(ndx, i) in columns" :key="'column-' + i" class="ma-0 pa-2" :class="'col-' + (12 / columns)">
                <template v-if="(n + i) < series.collections.length">
                  <v-card
                      class="ma-2 my-0"
                      color="transparent"
                      flat
                      tile
                      height="100%"
                      link
                  >
                    <v-hover v-slot="{ hover }">
                      <v-img
                          :src="series.collections[i + n].thumbnail"
                          @click.prevent="goToCollection(series.collections[i + n])"
                          eager
                      >
                        <!-- CHIP FOR DURATION -->
                        <v-chip
                            v-if="series.collections[i + n].duration && series.collections[i + n].type === 'video' && !series.collections[i + n]['live_video']"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                        >
                          {{ series.collections[i + n].duration.formatted.substring(0, 3) === '00:' ? series.collections[i + n].duration.formatted.substring(3) : series.collections[i + n].duration.formatted }}
                        </v-chip>
                        <!-- CHIP FOR LIVE VIDEO -->
                        <v-chip
                            v-if="series.collections[i + n].duration && series.collections[i + n].type === 'video' && series.collections[i + n]['live_video']"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="secondary"
                        >
                          {{ series.collections[i + n]['live_status'] }}
                        </v-chip>
                        <v-fade-transition v-if="series.collections[i + n].type === 'video' && hover">
                          <v-overlay
                              v-if="hover"
                              absolute
                              color="black"
                          >
                            <v-icon
                                v-if="!series.collections[i + n]['live_video'] || series.collections[i + n]['live_status'] !== 'pending'"
                                color="primary"
                                large
                            >
                              fas fa-play
                            </v-icon>
                            <v-icon
                                v-else
                                color="primary"
                                large
                            >
                              fas fa-info-circle
                            </v-icon>
                          </v-overlay>
                        </v-fade-transition>
                      </v-img>
                    </v-hover>
                    <v-card-text class="d-flex justify-space-between align-start">
                      <div>
                        <div v-if="series.collections[i + n].name" @click.prevent="goToCollection(series.collections[i + n])"><strong>{{ series.collections[i + n].name }}</strong></div>
                        <div v-if="series.collections[i + n].type === 'video' && series.collections[i + n]['live_video'] && series.collections[i + n]['live_status'] === 'pending'">{{ $moment(series.collections[i + n]['scheduled_at']).format('L LT')}}</div>
                        <div v-if="series.collections[i + n].type === 'video' && series.collections[i + n].episodeNumber">{{ $t('labels.episode') }} {{ series.collections[i + n].episodeNumber }}</div>
                        <div v-if="series.collections[i + n].type === 'file' && series.collections[i + n].size">{{ series.collections[i + n].size.formatted }}</div>
                      </div>
                      <div>
                        <v-btn
                            color="primary"
                            icon
                            small
                            @click.prevent="toggleDescription(series.collections[i + n].id)"
                        >
                          <v-icon
                              v-if="!showDescriptions.includes(series.collections[i + n].id)"
                              dark
                              small
                          >
                            fal fa-chevron-down
                          </v-icon>
                          <v-icon
                              v-if="showDescriptions.includes(series.collections[i + n].id)"
                              dark
                              small
                          >
                            fal fa-chevron-up
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-card-text>
                    <v-card-text v-if="showDescriptions.includes(series.collections[i + n].id)" style="max-height: 200px;" class="overflow-y-auto">
                      <div v-if="series.collections[i + n].description" v-html="toMarkdown(series.collections[i + n].description)"></div>
                    </v-card-text>
                  </v-card>
                </template>
              </div>
            </div>
          </v-carousel-item>
        </template>
      </v-carousel>
    </div>

    <!-- LOADER SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="isLoading">
      <template v-for="n in 4">
        <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="n">
          <v-card
              class="ma-2 my-0"
              color="transparent"
              flat
              tile
              height="100%"
          >
            <v-skeleton-loader
                type="image"
            ></v-skeleton-loader>
            <v-card-text>
              <v-skeleton-loader
                  class="mt-1"
                  type="text"
              ></v-skeleton-loader>
              <v-skeleton-loader
                  type="text"
              ></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </div>
      </template>
    </div>

    <!-- INFO DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="collection.thumbnail"
            :src="collection.thumbnail"
            max-height="400"
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title class="text-break" v-if="collection.name"><strong>{{ collection.name }}</strong></v-card-title>
        <v-card-text class="fill-height">
          <div v-if="collection.description" v-html="toMarkdown(collection.description)"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-series",
  props: ['collection', 'initialShowAll', 'isDetails'],
  data() {
    return {
      isLoading: false,
      isMovieLoading: false,
      model: null,
      series: {},
      showItemDialog: false,
      showDescriptions: [],
      showAll: false,
      movie: {},
      baseUrl: '',
      player: null,
      videoStartTime: 0
    }
  },

  mounted(){    
    this.baseUrl = window.location.origin
    this.showAll = this.initialShowAll
    if (this.collection.id && this.collection.type === 'category'){
      this.fetchSeries() 
    }
    if (this.collection.id && this.collection.type === 'series'){
      this.fetchMovies(this.collection.id)
    }
    if (this.collection.id && this.collection.type === 'video'){
      this.fetchMovie(this.collection.id)
      this.fetchMovies(this.collection.metadata['series_id'])
    }
  },
  
  computed: {
    /*maxItemsToShow(){
      if (!this.series || !this.showAll){
        return 4
      }
      if (this.showAll){
        return this.series.collections.length
      }
      return 4
    },*/

    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }
      
      if (this.$vuetify.breakpoint.lg) {
        return 4;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      return 1;
    }
  },

  methods: {
    logPlayer(){
      const that = this
      let videoExists = document.getElementById("video")
      if (videoExists){ 
        console.log('VIDEO EXISTS')
        that.player = new VHX.Player('video'); // eslint-disable-line
        let interval

        // events
        that.player.on('play', function() {
          // the video has started playing      
          // console.log('play', event)
          let duration = 100
          if (that.player.getVideoDuration()){
            duration = that.player.getVideoDuration() 
          }
          that.videoStartTime = that.player.currentTime()
          let timing = duration / 10
          that.logProgress()
          interval = setInterval(that.logProgress, timing.toFixed() * 1000)
        });

        that.player.on('pause', function() {
          // the video has started playing      
          // console.log('pause', event)
          that.logProgress()
          clearInterval(interval)
        });

        that.player.on('ended', function() {
          // the video has reached the end of playback
          that.logProgress()
          that.logProgress(true)
          clearInterval(interval)
        });
        
      }
    },

    async logProgress(completed) {
      let duration = this.player.getVideoDuration()
      let currentTime = this.player.currentTime()
      let progress = (currentTime / duration) * 100
      let videoTimeWatched = currentTime - this.videoStartTime
      
      if (videoTimeWatched > 0 || completed){
        let data = {
          videoPercentageWatched: progress.toFixed(),
          videoDuration: duration.toFixed(),
          videoTimeWatched: videoTimeWatched.toFixed()
        }

        this.videoStartTime = currentTime

        console.log(data)
        if (!completed){
          this.$root.$emit('post-vimeo-video-progress', data) 
        }

        if (completed){
          this.$root.$emit('post-vimeo-video-completed', data)
        }
      }
    },
    
    
    async fetchSeries(){
      this.isLoading = true
      let series = await api.watch.getSeries(this.collection.id).then((res) => { return res.data })
      if (series){
        this.series = series
      }
      this.isLoading = false
    },

    async fetchMovies(id){
      this.isLoading = true
      if (id) {
        let series = await api.watch.getMovies(id).then((res) => { return res.data })
        if (series){
          this.series = series
        } 
      }
      this.isLoading = false
    },

    async fetchMovie(id){
      this.isMovieLoading = true
      let movie = await api.watch.getMovie(id).then((res) => { return res.data })
      // let movieDetails = await api.watch.getMovieDetails(id).then((res) => { return res.data })
      if (movie){
        // console.log(movie)
        this.movie = movie
      }
      // if (movieDetails){
      //   console.log(movieDetails)
      // }
      this.isMovieLoading = false
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
    
    toggleDescription(id){
      if(this.showDescriptions.includes(id)){
        this.showDescriptions.splice(this.showDescriptions.indexOf(id), 1)
      } else {
        this.showDescriptions.push(id)
      }
    },

    toMarkdown(data){
      if (!data){ return '' }
      let text = data
      text = text.replace(/\n/g, " <br/> ")
      let splittedText = text.split(" ")
      splittedText.forEach((item, n) => {
        if (item.substring(0,4).toLowerCase() === "http"){
          splittedText[n] = "<a href='" + item + "' target='_blank'>" + item + "</a>"
        }
      })
      let joinedText = splittedText.join(" ")
      return joinedText
    },
    
    async goToCollection(serie){
      if (serie.type === 'category'){ this.navigate("/browse/" + serie.id) }
      if (serie.type === 'series'){ this.navigate("/series/" + serie.id) }
      if (serie.type === 'video'){ this.navigate("/videos/" + serie.id) }

      if (serie.type === 'file'){ 
        let response = await api.watch.getAsset(serie.id, 'VIMEO').then((res) => { return res.data })
        if (response.status === 'success'){
          if (response.result.system === 'TYPEFORM'){ this.navigate("/survey/" + response.result.assetId) }
          if (response.result.system === 'PDF'){ this.navigate("/pdf/" + response.result.assetId) }
        } else {
          window.open(serie['_links'].source.href, '_blank')  
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
